import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TxmManagementRoutingModule } from './txm-management-routing.module';
import { TxmManagementComponent } from './txm-management.component';
import { TxmTeamManagementComponent } from './txm-team-management/txm-team-management.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { TxmOpcodeListComponent } from './txm-opcode-list/txm-opcode-list.component';


@NgModule({
  declarations: [TxmManagementComponent, TxmTeamManagementComponent, TxmOpcodeListComponent],
  imports: [
    CommonModule,
    TxmManagementRoutingModule,
    TranslateModule,
    SharedModule,
    TranslateModule
  ],
  exports:[TranslateModule],
})
export class TxmManagementModule { }
